import { writable, type Writable } from 'svelte/store';

import type {
  AddAddressInterface,
  AddressResponseInterface,
  PaymentStoresInterface,
  availableOffersInterface,
  cityStateInterface,
  discountStoreInterface,
  soTokenInterface,
} from '../services/Interfaces';
export const addAddressInitialValue: AddAddressInterface = {
  fullname: '',
  mapped_email: '',
  address: '',
  addresstype: 'home',
  city: '',
  email: '',
  firstname: '',
  lastname: '',
  // @ts-ignore
  pincode: '',
  state: '',
  phone: '',
};

export let store_page: Writable<number> = writable(0); //values: 0=loader,1=phone-number, 2=otp, 3,4= add address, 5=address listing, 7=place order, 8=upi, 9=cod
export let store_payWith: Writable<string> = writable('');
export let store_phoneNo: Writable<string> = writable('');
export let store_confirmClose: Writable<boolean> = writable(false);
export let store_discountCode: Writable<discountStoreInterface> = writable({
  code: '',
  callDiscountAPI: false,
  credits: false,
  discountType: null,
  offerId: '',
  isLoyalty: false,
  isRemovableCartDiscount: false,
});

export let store_orderType: Writable<string> = writable('');
export let store_environment: Writable<string> = writable('');
export let store_soToken: Writable<soTokenInterface> = writable({ token: null, source: null });

export let store_pincode: Writable<string> = writable(null);
export let store_cityState: Writable<cityStateInterface> = writable({ city: '', state: '', country: 'IN' });
export let store_allAddresses: Writable<Array<AddressResponseInterface>> = writable([]);
export let store_selectedAddress: Writable<AddressResponseInterface | null> = writable(null);
export let store_selectedAddressServiceable: Writable<boolean> = writable(true);
export let store_selectedAddressEmail: Writable<string> = writable('');
export let store_isAbandonCart: Writable<boolean> = writable(false);
export let store_notificationOption: Writable<boolean> = writable(true);
export let store_triggerContinueFunction: Writable<any> = writable(null);
export let store_order_summary_drawer: Writable<boolean> = writable(false);
export let store_discount_drawer: Writable<boolean> = writable(false);
export let store_newUser: Writable<boolean> = writable(false);
export let store_truecallerActive: Writable<boolean> = writable(false);
export let store_isSkipOtp: Writable<boolean> = writable(false);
export const store_skipOtpMobile: Writable<string> = writable('');
export let store_visibility: Writable<boolean> = writable(true);
export let store_partialAddressId: Writable<number> = writable(null);
export let store_partialAddress: Writable<AddAddressInterface> = writable(null);
export let store_enableRecipientPhone: Writable<boolean> = writable(false);
export let store_kpLogin: Writable<boolean> = writable(false);
export let store_kpEmail: Writable<string> = writable('');
export let store_merchantUserType: Writable<string> = writable('');
// merged stores
export let store_upiPaymentOptionsAvailable: Writable<PaymentStoresInterface> = writable({
  gpay: false,
  phonepe: false,
  credpay: false,
});
export let store_isGlanceEnvironment: Writable<boolean> = writable(false);
export let store_paymentMethodByOffer: Writable<{ methodName: string; offer: availableOffersInterface | null }> =
  writable({ methodName: '', offer: null });
